export const focusOn = (inputName: string) => {
  window.document.getElementById(`${inputName}-input`)?.focus({ preventScroll: true });
  window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
};
